import type { StepDataFragment } from '@haaretz/s-fragments/StepData';

export default function getFirstStep(steps: StepDataFragment[]) {
  if (!(Array.isArray(steps) && steps.length)) throw new Error('A "steps" array is required');

  return steps[0];
}
